const animationVideo = document.getElementById('animation-video')

if (animationVideo) {
  const animationVideoObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          animationVideo.play()
        }
      })
    },
    {
      root: null,
      rootMargin: '0px',
      threshold: 0.5,
    }
  )

  animationVideoObserver.observe(animationVideo)
}
